// Modules
import { memo } from 'react'

// Components
import { TextSm, TextXs } from 'components'
import WrapperInfoItem from 'components/InfoItem/WrapperInfoItem'


const InfoItem = (props) => {
  const { title, value, customColor, customFontWeight = 600, ...rest } = props

  return (
    <WrapperInfoItem
      {...rest}
      fontSize="13px"
      fontWeight="400"
      lineHeight="24px"
      flexWrap="nowrap" 
      shrink={0}
      color="#fff"
      display="flex"
      flexDirection="column"
      px="12px"
      py="3"
    >
      <TextXs fontWeight="500"
      fontSize={{ lg: "12px", xl: "14px"  , "2xl": "16px" }}>
        {title}
      </TextXs>
      <TextSm fontWeight={customFontWeight}
      fontSize = {{ lg: "12px", xl: "14px" , "2xl": "16px" }}
      color={customColor}>
        {value ? value : '-'}
      </TextSm>
    </WrapperInfoItem>
  )
}

export default memo(InfoItem)
